import { useMemo } from 'react';

import { interactionToolsConfig } from '@vimeo/live-core/configs/InteractionToolsConfig';
import { IChatMessage, TChatHistory } from '@vimeo/live-core/types/interaction_tools';

/**
 * Returns sliced and sorted array of chat messages.
 * @param rawMessages - chat history object from firebase
 */
export function useChatHistoryMessages(rawMessages: TChatHistory): Array<IChatMessage> {
  return useMemo(() => {
    // todo: Filter by message types?
    return Object.values(rawMessages).slice(-interactionToolsConfig.CHAT.IN_MEMORY_MESSAGES_LIMIT);
  }, [rawMessages]);
}
